import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-education-kit',
  templateUrl: './education-kit.component.html',
  styleUrls: ['./education-kit.component.scss']
})
export class EducationKitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
